import { accessTokenStore } from 'entities/index';
import { SSOApi } from 'shared/api';

export const logOut = async () => {
  await SSOApi.logout();
  accessTokenStore.clear();
  window.location.reload();
};
